import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Get your `}<a parentName="p" {...{
            "href": "/docs/getting-started/install?tab=snippet"
          }}>{`PostHog snippet`}</a>{` with your project API key and instance address from `}<a parentName="p" {...{
            "href": "https://us.posthog.com/settings/project"
          }}>{`your project settings`}</a>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Assuming you have already set up Google Tag Manager, go to your `}<a parentName="p" {...{
            "href": "https://tagmanager.google.com/"
          }}>{`dashboard`}</a>{` and navigate to the desired account/container that is integrated with the website you want to add PostHog tracking to.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click to add a new tag:`}</p>
        <p parentName="li"><img parentName="p" {...{
            "src": "https://res.cloudinary.com/dmukukwp6/image/upload/v1710055416/posthog.com/contents/images/tutorials/gtm/dashboard.png",
            "alt": "GTM Dashboard"
          }}></img></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under `}<strong parentName="p">{`Tag Configuration`}</strong>{`, choose `}<strong parentName="p">{`Custom HTML`}</strong>{` and add your PostHog snippet.`}</p>
        <p parentName="li"><img parentName="p" {...{
            "src": "https://res.cloudinary.com/dmukukwp6/image/upload/Clean_Shot_2024_10_29_at_16_25_01_2x_1e99eea9d1.png",
            "alt": "PostHog snippet"
          }}></img></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`For the trigger, select the default `}<strong parentName="p">{`All Pages - Page View`}</strong>{` trigger and then click `}<strong parentName="p">{`Save`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Back on the main dashboard, click `}<strong parentName="p">{`Submit`}</strong>{` to update your website with the new PostHog tag.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You're done! PostHog is now added to your site and autocapturing data like pageviews and clicks.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      